import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import { CALIBRATION_SENTENCE, calibrationTips } from "@/lib/micCalibration";

const TONE = {
  good: ["border-emerald-200 bg-emerald-50 text-emerald-800", CheckCircle2],
  warn: ["border-amber-200 bg-amber-50 text-amber-800", AlertTriangle],
  bad: ["border-rose-200 bg-rose-50 text-rose-800", XCircle],
};

export const MicPrompt = ({ phase }) => {
  if (phase === "quiet") return <p data-testid="mic-calibration-quiet" className="mt-3 rounded-lg bg-slate-100 p-3 text-sm text-slate-700"><b>Step 1:</b> Stay silent for a moment while we measure room noise…</p>;
  if (phase === "speak") return <p data-testid="mic-calibration-speak" className="mt-3 rounded-lg bg-indigo-50 p-3 text-sm text-indigo-900"><b>Step 2:</b> Read aloud now: <span className="font-semibold">"{CALIBRATION_SENTENCE}"</span></p>;
  return null;
};

export const MicTips = ({ stats }) => {
  const tips = calibrationTips(stats);
  if (!tips.length) return null;
  return (
    <div data-testid="mic-calibration-tips" className="mt-3 space-y-2">
      {stats && !stats.error && (
        <div className="grid grid-cols-3 gap-2 font-mono text-[11px] text-slate-500" data-testid="mic-calibration-metrics">
          <span className="rounded bg-slate-100 px-2 py-1">Noise {(stats.noise * 1000).toFixed(1)}</span>
          <span className="rounded bg-slate-100 px-2 py-1">Voice {(stats.voice * 1000).toFixed(1)}</span>
          <span className="rounded bg-slate-100 px-2 py-1">Clipping {Math.round(stats.clip * 100)}%</span>
        </div>
      )}
      {tips.map((t, i) => {
        const [cls, Icon] = TONE[t.tone];
        return (
          <div key={i} data-testid={`mic-tip-${i}`} data-tone={t.tone} className={`flex gap-2 rounded-lg border p-3 ${cls}`}>
            <Icon className="mt-0.5 h-4 w-4 shrink-0" />
            <div><div className="text-sm font-semibold">{t.title}</div><div className="text-xs opacity-90">{t.text}</div></div>
          </div>
        );
      })}
    </div>
  );
};
